import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Features
import { DashboardsComponent } from './dashboards/dashboards.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { PipedriveComponent } from './pipedrive/pipedrive.component';

const routes: Routes = [
    {
      path: "",
      component: DashboardsComponent
    },
    {
      path: 'products', 
      loadChildren: () => import('./products/products.module').then(m => m.ProductsModule), 
      canActivate: [AuthGuard]
    },
    {
      path: "customers",
      loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule),
      canActivate: [AuthGuard]
    },
    {
      path: "pipedrive",
      component: PipedriveComponent
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
